import { useTranslation } from "react-i18next";
import BooleanValue from "./controls/BooleanValue";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import ListValue from "./controls/ListValue";
import MeasureValue from "./controls/MeasureValue";
import ObjectValue from "./controls/ObjectValue";
import TextValue from "./controls/TextValue";
import Col from "./layout/Col";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import PointValue from "./controls/PointValue";
import LongTextValue from "./controls/LongTextValue";
import LabeledValue from "./controls/LabeledValue";
import Label from "./controls/Label";
import ArrayValue from "./controls/ArrayValue";
import { DuctoSchema } from "../data/DuctoSchema";

export function DuctoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => {
        const isInvalid = !DuctoSchema.isValidSync(item, {
          abortEarly: false,
        });
        return (
          <ListGroupObjectItem
            key={item.orden ?? index}
            index={index}
            value={item}
            indexLabel={t("ducto.orden")}
            className={isInvalid ? "has-error" : ""}
            editable
            onEdit={(event) => {
              event.preventDefault();
              select(index);
              document.getElementById("chimeneas").scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            deletable
            onDelete={(event) => {
              event.preventDefault();
              remove(index);
            }}
            disabled={disabled}
          >
            {({ value }) => (
              <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("ducto.numeroDucto")}
                    value={value.numeroDucto}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextValue
                    label={t("ducto.referencia")}
                    value={value.referencia}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("ducto.operacionesUnitarias")}
                    labelAttr="nombre"
                    value={value.operacionesUnitarias}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("ducto.funcionamientoContinuo")}
                    value={value.funcionamientoContinuo}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ObjectValue
                    label={t("ducto.funcionamiento")}
                    value={value.funcionamiento}
                  >
                    {({ value }) => (
                      <Grid>
                        <Row>
                          <Col>
                            <MeasureValue
                              label={t("funcionamiento.horas")}
                              value={value.horas}
                            />
                          </Col>
                          <Col>
                            <MeasureValue
                              label={t("funcionamiento.dias")}
                              value={value.dias}
                            />
                          </Col>
                          <Col>
                            <MeasureValue
                              label={t("funcionamiento.meses")}
                              value={value.meses}
                            />
                          </Col>
                        </Row>
                      </Grid>
                    )}
                  </ObjectValue>
                </Col>
              </Row>
              <Row>
                <Col>
                  <PointValue
                    label={t("ducto.ubicacion")}
                    value={value.ubicacion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("ducto.seccion")}
                    value={value?.seccion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("ducto.altura")}
                    value={value?.altura}
                  />
                </Col>
                <Col>
                  <MeasureValue
                    label={t("ducto.diametro")}
                    value={value?.diametro}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("ducto.temperatura")}
                    value={value?.temperatura}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("ducto.velocidadSalida")}
                    value={value?.velocidadSalida}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("ducto.caudal")}
                    value={value?.caudal}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ArrayValue
                    label={t("ducto.caudalMasico")}
                    value={value?.caudalMasico}
                  >
                    {({ value: mediciones }) => (
                      <ListGroup>
                        <ListGroupItem>
                          <Grid>
                            <Row>
                              <Col lg={1}>#</Col>
                              <Col lg={4}>{t("medicion.contaminante")}</Col>
                              <Col lg={4}>{t("medicion.cantidad")}</Col>
                            </Row>
                          </Grid>
                        </ListGroupItem>
                        {mediciones.map((medicion) => (
                          <ListGroupItem key={medicion.contaminante.codigo}>
                            <Grid>
                              <Row>
                                <Col lg={1}>
                                  <Label>{index + 1}</Label>
                                </Col>
                                <Col lg={4}>
                                  <LabeledValue
                                    value={medicion.contaminante}
                                    labelAttr="nombre"
                                  />
                                </Col>
                                <Col lg={4}>
                                  <MeasureValue value={medicion.cantidad} />
                                </Col>
                              </Row>
                            </Grid>
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    )}
                  </ArrayValue>
                </Col>
              </Row>
              <LongTextValue
                label={t("ducto.descripcionTratamiento")}
                value={value?.descripcionTratamiento}
              />
              </Grid>
            )}
          </ListGroupObjectItem>
        );
      })}
    </ListGroup>
  );
}
